<template>
  <div v-if="frame" class="single-choice-tag" :style="[contentColors]"  v-on:click.stop v-on:mouseleave.stop>
    <div v-if="!submitted" class="single-choice-content" :style="[contentStyles]">
      <div class="question-mark" :style="'color:' + this.colors[7]">
        <i class="material-icons" >
          help_outline
        </i>
      </div>
      <h1 class="question">{{question}}</h1>
      <ul :class="listClasses">
        <li v-for="(option, key) in options" v-bind:key="keyPart + key" class="answer _flxrscntr" :style="[boxColors, boxWidth]" :class="{'answer-image': hasImage}" @click="onClick(option)">
            <!-- <div v-if="option.image">
              <img :src="option.image" />
            </div>
            <div v-if="option.text">
              <p v-for='(line, key) in option.text[selectedLanguage].split("\n")' v-bind:key="key">{{line}}</p>
            </div> -->
          <div v-if="hasImage" class="single-choice-option-image-content _flxrscntr">
            <div class="single-choice-option-image-content image" v-if="hasImage && displayOptionImage(option.image)" :style="[imageBox, {'background' : 'url(' + displayOptionImage(option.image) + ') no-repeat center center'}]">
            </div>
            <div v-if="option.text && option.text[selectedLanguage]">
              <p v-for='(line, key) in option.text[selectedLanguage].split("\n")' v-bind:key="key">{{line}}</p>
            </div>
          </div>
          <div v-if="!hasImage" class="single-choice-option-content _flxrscntr">
            <div v-if="option.text && option.text[selectedLanguage]">
              <p v-for='(line, key) in option.text[selectedLanguage].split("\n")' v-bind:key="key">{{line}}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="feedback && submitted" class="single-choice-content">
      <div class="question-mark">
        <i class="material-icons" >
          chat_bubble_outline
        </i>
      </div>
      <div class="single-choice-tag-feedback _flxrscntr">
        {{ feedback }}
      </div>
    </div>
  </div>
</template>
<script>
import * as Sortable from "sortablejs/Sortable.js";
import {
  isInScormLMS,
  setScore,
  setSessionTime,
  setLessonLocation
} from "./scormintegration";
import { evaluateQuizAnswerBoxStyles, evaluateQuizBoxStyles } from "./utils.js";
import { whiteColor, blackColor } from "./utils";
import { base, singleChoice, hasImagesOnly } from "./mixins/multilang";
import { analytics } from './mixins/analytics/'

export default {
  name: "singleChoiceTag",
  props: ["meta", "frame", "isLastFrame", "dimensions"],
  mixins: [base, singleChoice, hasImagesOnly, analytics],
  watch: {
    isLastFrame(value) {
      if (value) {
        this.$emit("show");
        this.videoElement.pause();
      }
    },
    singleChoice: "initTag"
  },
  data() {
    // const options = this.singleChoice.isSortable ? this.shuffle(this.singleChoice.options) : this.singleChoice.options
    // const values = new Array(this.singleChoice.options.length)
    return {
      submitted: false,
      feedback: "",
      isCorrect: false,
      videoElement: null,
      hasImage: false,
      options: null,
      keyPart: new Date().toTimeString()
    };
  },
  computed: {
    listClasses: function() {
      const classes = [];
      classes.push(this.alignment);
      classes.push(this.hasImagesOnly ? "images-only" : "");
      return classes;
    },
    imageBox: function() {
      // version to kick off update from forceUpdate
      var v = this.version
      if (this.hasImage || this.alignment === 'h-layout') {
        // square image
        let so = {"height": `${this.dimensions.w / 7 - 20}px !important`};
        return so
      }
    },
    boxWidth: function() {
             // version to kick off update from forceUpdate
      var v = this.version
      if (this.hasImage || this.alignment === 'h-layout') {
        //Todo: Maybe there is a better wy to calculate the vw
        // return {"width": `${22 - Math.ceil(this.meta.quiz.answers.length * (1 + this.meta.quiz.answers.length / 7))}vw !important`};
        // do not use vw or vh, as when embededded this does not conform to the size of the embedded iFrame
        const width = this.dimensions.w / Math.ceil(this.options.length * (1 + this.options.length / 9))
        let so = {"width": `${width < 400 ? width : 400}px !important`};
        return so
      }
    },
    boxColors: function() {
      return {
        color: this.colors[1] || blackColor,
        "background-color": this.colors[2] || whiteColor
      };
    },
    contentStyles: function() {
      return evaluateQuizBoxStyles(
        this.options,
        this.dimensions,
        this.alignment
      );
    },
    contentColors: function() {
      return {
        color: this.colors[0] || blackColor,
        "background-color": this.colors[4] || whiteColor
      };
    }
  },
  created() {
    this.$nextTick(() => {
      this.videoElement = document.getElementsByClassName("viewer-video")[0];
    });
    console.log("singleChoiceTag created", this.singleChoice);
    this.sessionStartTime = new Date().getTime();
    this.initTag();
  },
  directives: {
    sortable: {
      inserted(el, binding) {
        Sortable.create(el, binding.value);
      }
    }
  },
  methods: {
    initTag() {
      this.singleChoice = this.meta.singleChoice;
      this.options = this.singleChoice.options;
      this.colors = this.singleChoice.colorScheme ? this.singleChoice.colorScheme.colors : []
      this.hasImage = this.singleChoice.hasImage === undefined || this.singleChoice.hasImage
      this.values = [];
      for (var i = 0; i < this.options.length; i++) {
        this.values[i] = false;
      }
      this.alignment = this.meta.singleChoice.alignement || "v-layout";
      console.log(
        "singleChoiceTag.inited",
        this.$vnode.tag,
        this.options,
        this.values
      );
    },
    update(i, value) {
      this.values[i] = value;
      console.log(this.$vnode.tag + ": update selected", i, this.values);
    },
    displayOptionImage(image) {
      let imageSrc = null
      if (typeof image === 'string') {
        imageSrc = image
      } else if (image) {
        imageSrc = this.getTextFromMultiLang(image, this.selectedLanguage || image.lang, this.version)
      }
      return imageSrc && imageSrc !== '' ? imageSrc : null
    },
    onClick(option) {
      console.log("onClick: ", option);
      this.submitted = true;
      this.feedback = option.feedback[this.selectedLanguage]; // see mixin for selectedLanguage
      var ft = option.feedback && this.singleChoice.feedbackTime > 0 ? this.singleChoice.feedbackTime : 0;

      // analytics
      this.trackSingleChoiceTag("SingleChoice", option, this.isCorrect ? 1 : 0)

      // chrome will block pop ups that are not triggered by an on click event
      // if action is open, then do not go into the timeout, but emit immediatly (from this click event)
      if (option.behaviour.value.action === 'open') {
         this.$emit("action", option.behaviour.value);
      } else {
        setTimeout(() => {
          // reset submitted for now, for repeated use
          this.submitted = false;
          this.$emit("action", option.behaviour.value);
          this.$emit("hide");
        }, ft * 1000);
      }
    },
    storeScore(score, passed) {
      // scorm score integration
      try {
        var inLMS = isInScormLMS();
        console.log("is in LMS", inLMS);
        if (inLMS) {
          // initialize scorm data
          setScore(score);
          var now = new Date().getTime();
          setSessionTime(now - this.sessionStartTime);
          setLessonLocation(this.quiz.question);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
